import { ValidationFunctionResult } from '../../../../types/validation-function-result';
import { VehicleFeatureItemDto } from '../../dtos/vehicle-feature-item.dto';
import { vehicleFeatureItemSchema } from '../schemas/vehicle-feature-item.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: VehicleFeatureItemDto,

	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!record) throw new Error('record is required.');

	// Validate
	const { error } = vehicleFeatureItemSchema().validate(record, {
		abortEarly,
	});

	// Check
	if (error) {
		return {
			isValid: false,
			errors: error.details?.map((e) => e.message),
		};
	}

	// Return
	return { isValid: true };
};
